import React, { useState, useMemo } from 'react';
import styles from '../../assets/styles/Admin.module.scss';
import { mockPayments, mockClients } from '../../mock/admin_mock';

const AdminPayments: React.FC = () => {
  // Use current date (e.g. 2026-04)
  const [currentDate, setCurrentDate] = useState(new Date('2026-04-01'));

  const handlePrevMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, 1));
  };

  const handleNextMonth = () => {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1));
  };

  const formattedMonth = `${currentDate.getFullYear()}年${currentDate.getMonth() + 1}月`;
  const monthPrefix = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}`;

  // For the selected month, build a list of all clients and their payment status
  const paymentsList = useMemo(() => {
    return mockClients.map(client => {
      // Find a payment for this client in the current month
      const payment = mockPayments.find(p =>
        p.clientId === client.id && p.date.startsWith(monthPrefix)
      );
      if (payment) {
        return payment; // Use actual payment record
      }
      // If no payment record found for this month, return a default representation
      return {
        id: `empty-${client.id}`,
        clientId: client.id,
        companyName: client.name,
        amount: 39800,
        status: '未決済',
        date: '-'
      };
    });
  }, [monthPrefix]);

  return (
    <div className={styles.contentBox}>
      <div className={`${styles.pageHeader} ${styles.pageHeaderFlex}`}>
        <div>
          <h1>決済状況 <span className={styles.mockNotice}>(moc)</span></h1>
          <p>クライアントの請求と支払い状況の確認</p>
          <div className={styles.totalSalesBox}>
            <span className={styles.totalSalesLabel}>合計売上</span>
            <span className={styles.totalSalesValue}>
              ¥{paymentsList.reduce((sum: number, p: any) => sum + p.amount, 0).toLocaleString()}
            </span>
          </div>
        </div>
        <div className={styles.monthSelector}>
          <button onClick={handlePrevMonth}>&lt;</button>
          <span>{formattedMonth}</span>
          <button onClick={handleNextMonth}>&gt;</button>
        </div>
      </div>

      <div className={styles.tableWrap}>
        <table className={styles.adminTable}>
          <thead>
            <tr>
              <th>請求ID</th>
              <th>企業名</th>
              <th>金額 (円)</th>
              <th>決済日</th>
              <th className={styles.textRight}>ステータス</th>
            </tr>
          </thead>
          <tbody>
            {paymentsList.map((payment: any) => (
              <tr key={payment.id}>
                <td>{typeof payment.id === 'number' ? `INV-${payment.id}` : '-'}</td>
                <td>{payment.companyName}</td>
                <td>¥{payment.amount.toLocaleString()}</td>
                <td>{payment.date}</td>
                <td className={styles.textRight}>
                  <span className={`${styles.badge} ${styles[payment.status]}`}>
                    {payment.status}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminPayments;
